import { render, staticRenderFns } from "./MapPedido.vue?vue&type=template&id=4fc21be0"
import script from "./MapPedido.vue?vue&type=script&lang=js"
export * from "./MapPedido.vue?vue&type=script&lang=js"
import style0 from "./MapPedido.vue?vue&type=style&index=0&id=4fc21be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports